var map = {
  "./de.json": "46477",
  "./en.json": "75553",
  "./es.json": "72706",
  "./fr.json": "74554",
  "./it.json": "66851",
  "./ja.json": "42551",
  "./nl.json": "86164",
  "./zh.json": "44028"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 94824;
